module.exports = __webpack_public_path__ + "static/img/GoogleLogo.6d435bea.svg";